var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0 auto","text-align":"center"}},[_c('h2',[_vm._v(_vm._s(_vm.$store.state.Login.Username)+",您好")]),_c('h2',[_vm._v("请点击右上角进行功能选择")]),_c('h3',[_vm._v("手机用户在打开扫描时提示是否使用摄像头，请点击允许！")])])
}
var staticRenderFns = []

export { render, staticRenderFns }